module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/banner/ko-06cb3316d42c61677c9b0967e2ced13d.jpg";